import ClientAbonPackageChange from "./client-abon-package-change";

const ClientItemAbonPackage = ({ item, expanded, setExpanded, onClose, onAbonsUpdate, clientId, saleUserId }) => {

  const handleHeaderClick = () => {
    setExpanded(!expanded);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return <div className={!expanded ? "client-subitem" : "client-subitem-selected"}>
    <div className="client-item-body" onClick={() => handleHeaderClick}>
      <div className="client-item-line-bold-double">
        <div className="client-item-clip">{item.productName}</div>
        <div className="client-item-clip-right">Остаток: {item.qtyRest}</div>
      </div>
      <div>
        <div className="client-item-clip">Продано: {item.qty}</div>
      </div>
    </div>
    {expanded && <div onClick={stopPropagation}>
        <ClientAbonPackageChange pack={item} clientId={clientId} saleUserId={saleUserId} onAbonsUpdate={onAbonsUpdate} onClose={onClose}/>
      </div>
    }
  </div>
}

export default ClientItemAbonPackage;